import { type Command } from "prosemirror-state";

import { handleArrowUpInComputeCell } from "./handleArrowUpInComputeCell";

export const handleArrowLeftInComputeCell: Command = handleArrowUpInComputeCell;
